
export const CONSTRUCTION_TYPE_LIST = [
  {
    id: 1,
    keyName: 'paint',
    text: '塗装',
  },
  {
    id: 2,
    keyName: 'replace',
    text: '張り替え',
  },
  {
    id: 3,
    keyName: 'repair',
    text: '補修',
  },
];
